<template>
  <div class="container">
    <div class="row">
      <div class="slopePage__title">
        <b>Material calculation</b>
      </div>
    </div>
    <div class="row computation">
      <div class="computation__head">
        <div class="computation__head-title">Group</div>
        <div class="computation__head-title">Material</div>
        <div class="computation__head-title justify-content-end
        justify-content-md-start">Number of panels</div>
        <div class="computation__head-title justify-content-end
        justify-content-md-start">Volume</div>
        <div class="computation__head-title">Drawing</div>
      </div>
      <div class="computation__body">
        <div v-for="(item, i) in computation" class="computation__item" :key="i">
            <div class="computation__item-img">
              <img :src="getMaterial(item.id).src"
                   :alt="getMaterial(item.id).name">
            </div>
            <div class="computation__item-material">
              <div class="name">
                {{ getMaterial(item.id).name }}
              </div>
              <div class="angle">
                <img src="@/assets/img/angle.svg" alt="angle">
                <b>{{ getMaterial(item.id).angle }}%</b>
              </div>
            </div>
            <div class="computation__item-plate">
              <div class="size">{{ item.width }}х{{ item.height }} mm</div>
              <div class="plate"><b><span>Panel</span> {{ item.plateType }}</b></div>
              <div class="info" v-if="item.hasOwnProperty('plateInfo')">{{ item.plateInfo }}</div>
            </div>
            <div class="computation__item-count">
              {{ item.count }} pc.
            </div>
            <div class="computation__item-volume"><span>{{ item.volume }} m³</span></div>
            <div class="computation__item-eye">
              <v-popover
                offset="10"
                placement="left"
                trigger="hover">
                <svg width="36" height="36" viewBox="0 0 36 36"
                     fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="36" height="36" rx="4" fill="white" class="overlay"></rect>
                  <path d="M18 20.3333C19.3255 20.3333 20.4 19.2886 20.4 18C20.4 16.7114
              19.3255 15.6667 18 15.6667C16.6745 15.6667 15.6 16.7114 15.6 18C15.6 19.2886 16.6745
                       20.3333 18 20.3333Z" fill="#C9C9C9" class="eye-main"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6 18C6 16.0105 11.36 11 18 11C24.64 11 30 16.0841 30
                    18C30 19.9895 24.64 25 18 25C11.36 25 6 19.9895 6 18ZM23.28
                    18C23.28 20.8351 20.9161 23.1333 18 23.1333C15.0839 23.1333
                    12.72 20.8351 12.72 18C12.72 15.1649 15.0839 12.8667 18 12.8667C20.9161
                    12.8667 23.28 15.1649 23.28 18Z" fill="#C9C9C9" class="eye-main"></path>
                </svg>
                <div slot="popover">
                  <img :src="item.src" alt=""
                       class="popover__plate-img">
                </div>
              </v-popover>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    getMaterial(id) {
      return this.allMaterials[this.allMaterials.findIndex(p => p.id === id)];
    },
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    result() {
      return this.$store.getters.getResult;
    },
    computation() {
      return this.result.total;
    },
  },
};

</script>

<style lang="sass" scoped>
.slopePage
  .computation
    border-radius: rem(4) rem(4) 0 0
    color: $black
    &__head
      background: #F6F6F6
      display: grid
      grid-template-columns: repeat(6, 1fr)
      width: 100%
      +media((grid-template-columns: (320: 2fr 1fr 1fr, 768: 1fr 1fr 1.5fr 1fr 1fr 1fr, 960: 4fr 4fr 1fr 5fr 3fr 3fr 1fr 3fr)))
      +media((padding: (320: 0 rem(24), 768: 0)))
      &-title
        min-height: rem(60)
        display: flex
        flex-direction: row
        align-items: center
        @extend .common__title-result
        text-align: left
        &:first-of-type
          grid-column-start: 2
          +media((display: (320: none, 768: flex)))
        // &:nth-child(2)
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(40))))
          // +media((min-width: (320: rem(150), 768: auto)))
        &:nth-child(2)
          +media((grid-column-start: (320: 1, 768: 3, 960: 4)))
        &:last-of-type
          +media((grid-column-start: (768: 6, 960: 8)))
          +media((display: (320: none, 768: flex)))
          text-align: center
          justify-content: center
        sup
          display: block
          margin-top: rem(-5)
        &--pl40
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(40))))
        &--pl70
          +media((padding-left: (768: rem(40), 992: rem(70))))
    &__body
      width: 100%
      display: grid
      margin-top: rem(1)
      grid-template-columns: 1fr
      grid-template-rows: 1fr
      grid-row-gap: rem(1)
    &__item
      background: #fff
      // grid-template-columns: repeat(6, 1fr)
      +media((grid-template-columns: (768: 1fr 1fr 1.5fr 1fr 1fr 1fr, 960:  4fr 4fr 1fr 5fr 3fr 3fr 1fr 3fr)))
      width: 100%
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(17)
      grid-row-gap: rem(1)
      min-height: rem(68)
      +media((display: (320: flex, 768: grid)))
      flex-direction: row
      flex-wrap: wrap
      +media((padding: (320: 0 rem(24), 768: rem(5) 0)))
      // +media((padding-bottom: (320: rem(12), 768: 0)))
      +media((height: (320: rem(96), 768: auto)))
      justify-content: space-between
      position: relative
      &:after
        content: ""
        position: absolute
        left: rem(24)
        height: rem(1)
        width: calc(100% - 48px)
        background: #ECECEC
        top: 50%
        transform: translateY(-50%)
        +media((display: (320: block, 768:none)))
      &-material, &-plate, &-count, &-volume
        text-align: left
        display: flex
        flex-direction: column
        justify-content: center
      &-material, &-count, &-plate, &-volume, &-eye
        +media((height: (320: rem(48), 768: auto)))
      &-material
        +media((order: (320: 1, 768: unset)))
        display: flex
        +media((flex-direction: (320: row, 768: column)))
        +media((align-items: (320: center, 768: flex-start)))
        +media((justify-content: (320: flex-start, 768: center)))
        +media((max-width: (320: rem(210), 360: 80%, 598: unset)))
        +media((min-width: (320: 80%, 598: 87%, 768: unset)))
        // +media((min-width: (320: rem(210), 360: 80%, 768: auto)))
        position: relative
        // &:after
          content: ""
          position: absolute
          left: rem(24)
          bottom: rem(5)
          height: rem(1)
          width: calc(100% - 24px)
          background: #ECECEC
          +media((display: (320: block, 768:none)))
        .angle
          display: flex
          flex-direction: row
          align-items: center
          img
            margin-right: rem(6)
            line-height: 0
      &-plate
        +media((order: (320: 3, 768: unset)))
        +media((flex-direction: (320: row-reverse, 768: column)))
        +media((align-items: (320: center, 768: flex-start)))
        +media((width: (320: 50%, 768: auto)))
        +media((justify-content: (320: flex-end, 768: center)))
        +media((grid-column-start: (768: 3, 960: 4)))
        .plate
          +media((padding-right: (320: rem(15), 768: 0)))
        span
          +media((display: (320: none, 400: inline-block)))
        .info
          +media((display: (320: none, 768: block)))
      &-count
        +media((order: (320: 4, 768: unset)))
        +media((width: (320: 25%, 768: auto)))
        +media((text-align: (320: right, 768: left)))
      &-volume
        +media((order: (320: 5, 768: unset)))
        +media((width: (320: 25%, 768: auto)))
        +media((text-align: (320: right, 768: left)))
      &-plate, &-count
        &--pl40
          +media((padding-left: (320: 0, 768: rem(20), 992: rem(40))))
      &-img
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        +media((display: (320: none, 768: flex)))
        img
          max-width: rem(92)
      &-eye
        display: flex
        flex-direction: row
        align-items: center
        position: relative
        justify-content: center
        +media((grid-column-start: (768: 6, 960: 8)))
        +media((order: (320: 2, 768: unset)))
        // &:after
          content: ""
          position: absolute
          left: 0
          bottom: rem(5)
          height: rem(1)
          width: calc(100%)
          background: #ECECEC
          +media((display: (320: block, 768:none)))
        &--pl70
          +media((padding-left: (320: 0, 768: rem(40), 992: rem(70))))
          svg
            cursor: pointer
            &:hover
              .overlay
                fill: $red
              .eye-main
                fill: #fff
.popover
  &__plate
    &-img
      padding: rem(50) rem(25) rem(45)
      max-width: rem(225)
</style>
